import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { config } from 'src/constants/firebase';

const app = !getApps().length ? initializeApp(config) : getApp();
const auth = getAuth(app);

export { app, auth };
